import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type ReferralTypeState = {
  referralsById: { [referralId: number]: Referral };
  referralsStateByOrgId: StateDictionary;
  referralsStateByJobId: StateDictionary;
};

type State = { referrals: ReferralTypeState };

const referralsByIdSelector = (state: State) => state.referrals.referralsById;
const referralsSelector = createSelector([referralsByIdSelector], (referralsById) =>
  Object.values(referralsById),
);

export const referralSelector = createSelector(
  [referralsByIdSelector, (_state: State, referralId: number) => referralId],
  (referralsById, referralId) => referralsById[referralId],
);

export const referralsForOrgIdSelector = createSelector(
  [referralsSelector, (_state: State, orgId: number) => orgId],
  // If there is a job associated with the referral, we can pull out the org from the job
  // If not, then the referral is an "other" job referral which was created by an employee but
  // doesn't have an associated job. Thus we can pull out the org from the employee
  (referrals, orgId) =>
    referrals.filter((r) => r.Job?.orgId === orgId || r.Employee?.orgId === orgId),
);

const referralsStateByOrgIdSelector = (state: State) => state.referrals.referralsStateByOrgId;
export const referralsStateForOrgIdSelector = createSelector(
  [referralsStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (referralsStateByOrgId, orgId) => referralsStateByOrgId[orgId],
);

export const referralsForJobIdSelector = createSelector(
  [referralsSelector, (_state: State, jobId: number) => jobId],
  (referrals, jobId) => referrals.filter((r) => r.jobId === jobId),
);

const referralsStateByJobIdSelector = (state: State) => state.referrals.referralsStateByJobId;
export const referralsStateForJobIdSelector = createSelector(
  [referralsStateByJobIdSelector, (_state: State, jobId: number) => jobId],
  (referralsStateByJobId, jobId) => referralsStateByJobId[jobId],
);
